import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

import api from '../../../../utils/API';
import { DetailsProductsRequest, DetailsRequest, DetailsSourceRequest, GaugeChartsBody, OmnichannelPreferences, OmnichannelSavedFilters } from './types';

let cancelTokenProduto;
let cancelTokenFiltros;

export const getProduto = (data, size) => {
  if (typeof cancelTokenProduto !== typeof undefined) {
    cancelTokenProduto.cancel('Operation canceled due to new request.');
  }

  cancelTokenProduto = axios.CancelToken.source();

  return trackPromise(
    api({
      url: `${process.env.REACT_APP_CLIENTE_URL}/painel_geral/filtros/produto`,
      method: 'POST',
      data: JSON.stringify(data),
      params: {
        size: size || 50,
      },
      cancelToken: cancelTokenProduto.token,
      expectToken: true,
    }).then(resp => resp.data),
    'product-filter',
  );
};

export const getItensFiltros = data => {
  if (typeof cancelTokenFiltros !== typeof undefined) {
    cancelTokenFiltros.cancel('Operation canceled due to new request.');
  }

  cancelTokenFiltros = axios.CancelToken.source();

  return trackPromise(
    api({
      url: `${process.env.REACT_APP_CLIENTE_URL}/painel_geral/filtros`,
      method: 'POST',
      data: JSON.stringify(data),
      cancelToken: cancelTokenFiltros.token,
      expectToken: true,
    }).then(resp => resp.data),
    'omnichannel-filter',
  );
};

export const getOmnichannelDetailingChains = data =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_CLIENTE_URL}/details`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
    }).then(resp => resp.data),
  );

export const getOmnichannelGaugeCharts = (data: GaugeChartsBody) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_OMNICHANNEL_COMPARISON_ENGINE_URL}/big-numbers`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
    }).then(resp => resp),
  );

export const getOmnichannelDetails = (data: DetailsRequest) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_OMNICHANNEL_COMPARISON_ENGINE_URL}/detail`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
    }).then(resp => resp),
    'omnichannel-details',
  );

export const getOmnichannelDetailsProducts = (data: DetailsProductsRequest) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_OMNICHANNEL_COMPARISON_ENGINE_URL}/detail/product`,
      method: 'POST',
      expectToken: true,
      params: {
        sort: data?.params?.sort || '',
        direction: data?.params?.direction || '',
      },
      data: JSON.stringify(data?.body),
    }).then(resp => resp),
  );

export const getOmnichannelPreferences = () =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_SETUP_URL}/omnichannel/preferences`,
      method: 'GET',
      expectToken: true,
    }).then(resp => resp),
  );

export const saveOmnichannelPreferences = (data: OmnichannelPreferences) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_SETUP_URL}/omnichannel/preferences`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
    }).then(resp => resp),
  );

export const getOmnichannelSavedFilters = (query: string) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_SETUP_URL}/omnichannel/filters/saved/search`,
      method: 'GET',
      params: {
        query: query,
      },
      expectToken: true,
    }).then(resp => resp),
    'omnichannel-filter',
  );

export const saveOmnichannelSavedFilters = (data: OmnichannelSavedFilters) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_SETUP_URL}/omnichannel/filters/saved`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
    }).then(resp => resp),
    'save-omnichannel-filter',
  );

export const downloadOmnichannelDetails = (type: 'csv' | 'xlsx', data: GaugeChartsBody) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_OMNICHANNEL_COMPARISON_ENGINE_URL}/detail/download/${type}`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
      responseType: 'arraybuffer',
    }).then(resp => {
      if (resp.status === 200) {
        const blob = new Blob([resp.data]);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = window.URL.createObjectURL(blob);
        hiddenElement.target = '_blank';
        hiddenElement.download = `detalhamento.${type}`;
        hiddenElement.click();
      }
    }),
  );

export const deleteOmnichannelSavedFilters = (id: number) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_SETUP_URL}/omnichannel/filters/saved`,
      method: 'DELETE',
      expectToken: true,
      params: {
        idFiltroSalvo: id,
      },
    }).then(resp => resp),
  );

export const getOmnichannelDetailsSource = (data: DetailsSourceRequest) =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_OMNICHANNEL_COMPARISON_ENGINE_URL}/detail/source`,
      method: 'POST',
      expectToken: true,
      data: JSON.stringify(data),
    }).then(resp => resp),
  );
